import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3f6d5cad = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _2ec9ae02 = () => interopDefault(import('..\\pages\\cooperation\\index.vue' /* webpackChunkName: "pages/cooperation/index" */))
const _861c6f7e = () => interopDefault(import('..\\pages\\email-download\\index.vue' /* webpackChunkName: "pages/email-download/index" */))
const _58ab225c = () => interopDefault(import('..\\pages\\guarantee\\index.vue' /* webpackChunkName: "pages/guarantee/index" */))
const _1599cf51 = () => interopDefault(import('..\\pages\\login\\index.vue' /* webpackChunkName: "pages/login/index" */))
const _78a23ac0 = () => interopDefault(import('..\\pages\\member\\index.vue' /* webpackChunkName: "pages/member/index" */))
const _f132280e = () => interopDefault(import('..\\pages\\qrcode-mobile\\index.vue' /* webpackChunkName: "pages/qrcode-mobile/index" */))
const _6bc3383e = () => interopDefault(import('..\\pages\\role-setting\\index.vue' /* webpackChunkName: "pages/role-setting/index" */))
const _7a6caf9d = () => interopDefault(import('..\\pages\\sign\\index.vue' /* webpackChunkName: "pages/sign/index" */))
const _6efce2d0 = () => interopDefault(import('..\\pages\\subscribe\\index.vue' /* webpackChunkName: "pages/subscribe/index" */))
const _477f7876 = () => interopDefault(import('..\\pages\\guarantee\\bh.vue' /* webpackChunkName: "pages/guarantee/bh" */))
const _73ee8d01 = () => interopDefault(import('..\\pages\\subscribe\\config\\index.js' /* webpackChunkName: "pages/subscribe/config/index" */))
const _070d0ece = () => interopDefault(import('..\\pages\\home\\section\\home-content.vue' /* webpackChunkName: "pages/home/section/home-content" */))
const _688b73b8 = () => interopDefault(import('..\\pages\\home\\section\\nav-banner.vue' /* webpackChunkName: "pages/home/section/nav-banner" */))
const _10e1e5b1 = () => interopDefault(import('..\\pages\\home\\section\\statistics.vue' /* webpackChunkName: "pages/home/section/statistics" */))
const _4a348d75 = () => interopDefault(import('..\\pages\\role-setting\\components\\list.vue' /* webpackChunkName: "pages/role-setting/components/list" */))
const _47bc16d0 = () => interopDefault(import('..\\pages\\subscribe\\components\\card.vue' /* webpackChunkName: "pages/subscribe/components/card" */))
const _2e582550 = () => interopDefault(import('..\\pages\\subscribe\\components\\card-item.vue' /* webpackChunkName: "pages/subscribe/components/card-item" */))
const _0e48e768 = () => interopDefault(import('..\\pages\\subscribe\\components\\form.vue' /* webpackChunkName: "pages/subscribe/components/form" */))
const _46fff85c = () => interopDefault(import('..\\pages\\subscribe\\components\\name-search.vue' /* webpackChunkName: "pages/subscribe/components/name-search" */))
const _5016460c = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _3f6d5cad,
    alias: "/about/index.html",
    name: "about"
  }, {
    path: "/cooperation",
    component: _2ec9ae02,
    alias: "/cooperation/index.html",
    name: "cooperation"
  }, {
    path: "/email-download",
    component: _861c6f7e,
    alias: "/email-download/index.html",
    name: "email-download"
  }, {
    path: "/guarantee",
    component: _58ab225c,
    alias: "/guarantee/index.html",
    name: "guarantee"
  }, {
    path: "/login",
    component: _1599cf51,
    alias: "/login/index.html",
    name: "login"
  }, {
    path: "/member",
    component: _78a23ac0,
    alias: "/member/index.html",
    name: "member"
  }, {
    path: "/qrcode-mobile",
    component: _f132280e,
    alias: "/qrcode-mobile/index.html",
    name: "qrcode-mobile"
  }, {
    path: "/role-setting",
    component: _6bc3383e,
    alias: "/role-setting/index.html",
    name: "role-setting"
  }, {
    path: "/sign",
    component: _7a6caf9d,
    alias: "/sign/index.html",
    name: "sign"
  }, {
    path: "/subscribe",
    component: _6efce2d0,
    alias: "/subscribe/index.html",
    name: "subscribe"
  }, {
    path: "/guarantee/bh",
    component: _477f7876,
    alias: "/guarantee/bh/index.html",
    name: "guarantee-bh"
  }, {
    path: "/subscribe/config",
    component: _73ee8d01,
    alias: "/subscribe/config/index.html",
    name: "subscribe-config"
  }, {
    path: "/home/section/home-content",
    component: _070d0ece,
    alias: "/home/section/home-content/index.html",
    name: "home-section-home-content"
  }, {
    path: "/home/section/nav-banner",
    component: _688b73b8,
    alias: "/home/section/nav-banner/index.html",
    name: "home-section-nav-banner"
  }, {
    path: "/home/section/statistics",
    component: _10e1e5b1,
    alias: "/home/section/statistics/index.html",
    name: "home-section-statistics"
  }, {
    path: "/role-setting/components/list",
    component: _4a348d75,
    alias: "/role-setting/components/list/index.html",
    name: "role-setting-components-list"
  }, {
    path: "/subscribe/components/card",
    component: _47bc16d0,
    alias: "/subscribe/components/card/index.html",
    name: "subscribe-components-card"
  }, {
    path: "/subscribe/components/card-item",
    component: _2e582550,
    alias: "/subscribe/components/card-item/index.html",
    name: "subscribe-components-card-item"
  }, {
    path: "/subscribe/components/form",
    component: _0e48e768,
    alias: "/subscribe/components/form/index.html",
    name: "subscribe-components-form"
  }, {
    path: "/subscribe/components/name-search",
    component: _46fff85c,
    alias: "/subscribe/components/name-search/index.html",
    name: "subscribe-components-name-search"
  }, {
    path: "/",
    component: _5016460c,
    alias: "/index.html",
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
